import { DealsState } from './state';
import { dealsInitialState } from './initial-state';
import { DealsActions } from './action-creators';
import * as actions from './actions';

export const dealsReducer = (
  state: DealsState = dealsInitialState,
  action: DealsActions
): DealsState => {
  switch (action.type) {
    case actions.GET_OWNER_DEALS_SUCCESS: {
      return {
        ...state,
        owned: action.deals,
      };
    }

    case actions.GET_ARTIST_DEALS: {
      return {
        ...state,
        participating: [],
      };
    }

    case actions.GET_ARTIST_DEALS_SUCCESS: {
      return {
        ...state,
        participating: action.deals,
      };
    }

    case actions.RESET_DEALS_STATE: {
      return {
        ...dealsInitialState,
      };
    }

    default: {
      return { ...state };
    }
  }
};
